import React, { useState } from 'react';
import MathDisplay from './MathDisplay';

const TestQuestion = ({ question, questionNumber, onAnswerSubmit, isAnswered }) => {
  const [selectedAnswer, setSelectedAnswer] = useState('');

  const handleAnswerSelect = (answer) => {
    if (isAnswered) return; // Prevent changing answer if already submitted
    setSelectedAnswer(answer);
  };

  const handleSubmit = () => {
    if (!selectedAnswer || isAnswered) return;
    onAnswerSubmit(selectedAnswer);
  };

  const isCorrect = isAnswered && selectedAnswer === question.right_answer;

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-800">
            မေးခွန်း {questionNumber}
          </h3>
          {isAnswered && (
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${
              isCorrect 
                ? 'bg-green-100 text-green-800' 
                : 'bg-red-100 text-red-800'
            }`}>
              {isCorrect ? 'မှန်ကန်' : 'မှားယွင်း'}
            </span>
          )}
        </div>
        
        <div className="text-gray-700 mb-6">
          <MathDisplay>{question.question}</MathDisplay>
        </div>

        <div className="space-y-3">
          {question.multiple_choices.map((choice, index) => {
            const choiceLetter = String.fromCharCode(65 + index); // A, B, C, D
            const isSelected = selectedAnswer === choice;
            const isRightAnswer = choice === question.right_answer;
            
            let buttonClass = 'w-full text-left p-4 rounded-lg border-2 transition-all duration-200 ';
            
            if (isAnswered) {
              if (isRightAnswer) {
                buttonClass += 'border-green-500 bg-green-50 text-green-800';
              } else if (isSelected && !isRightAnswer) {
                buttonClass += 'border-red-500 bg-red-50 text-red-800';
              } else {
                buttonClass += 'border-gray-200 bg-gray-50 text-gray-600';
              }
            } else {
              if (isSelected) {
                buttonClass += 'border-blue-500 bg-blue-50 text-blue-700';
              } else {
                buttonClass += 'border-gray-200 hover:border-blue-300 hover:bg-blue-25';
              }
            }

            return (
              <button
                key={index}
                onClick={() => handleAnswerSelect(choice)}
                className={buttonClass}
                disabled={isAnswered}
              >
                <div className="flex items-center">
                  <span className="font-medium mr-3 min-w-[24px]">
                    {choiceLetter}.
                  </span>
                  <MathDisplay inline>{choice}</MathDisplay>
                </div>
              </button>
            );
          })}
        </div>

        {!isAnswered && selectedAnswer && (
          <div className="mt-6">
            <button
              onClick={handleSubmit}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors"
            >
              အဖြေတင်သွင်းမည်
            </button>
          </div>
        )}

        {isAnswered && (
          <div className="mt-6 p-4 bg-blue-50 rounded-lg">
            <h4 className="font-medium text-blue-800 mb-2">ရှင်းလင်းချက်:</h4>
            <p className="text-blue-700 text-sm">
              <MathDisplay>{question.reason}</MathDisplay>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestQuestion;
